import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import { ScreenText } from '@/lang/ScreenText'
import formsStore from '@/store/modules/forms/formsStore'

@Component({
  name: 'widget-form-item',
  components: {}
})
export default class WidgetFormItem extends Vue {
  private objScreenText: ScreenText = new ScreenText()

  @Prop()
  data!: any

  @Prop()
  select!: any

  @Prop()
  element!: any

  @Prop()
  index!: any

  @Prop()
  dropIndex!: any

  @Prop()
  formIndex!: number
  /* istanbul ignore next */
  get applicationParts() {
    return formsStore.applicationsPartsData.forms
  }
  /* istanbul ignore next */
  get formData() {
    return this.applicationParts[this.formIndex]
      ? this.applicationParts[this.formIndex].source
      : { list: [], config: {} }
  }

  public selectWidget: any = this.select
  /* istanbul ignore next */
  @Watch('select', { deep: true })
  watchselect(value: any) {
    this.selectWidget = value
  }

  @Watch('selectWidget', { deep: true })
  watchselectWidget(val: any) {
    this.$emit('update:select', val)
  }

  handleSelectWidget(element: any, index: number) {
    /* istanbul ignore else */
    if (element.isDrag) {
      this.selectWidget = this.data.list[index]
    }
  }

  handleWidgetDelete(index: number) {
    if (this.data.list.length - 1 === index) {
      if (index === 0) {
        this.selectWidget = {}
      } else {
        this.selectWidget = this.data.list[index - 1]
      }
    } else {
      this.selectWidget = this.data.list[index + 1]
    }

    this.$nextTick(() => {
      this.data.list.splice(index, 1)
    })
  }
  closeAllDropDown() {
    const elements = this.data.list
    elements.forEach((element: any) => {
      if (element.elmType === 'addressGrid') {
        element.columns.forEach((item: any) => {
          item.list.forEach((itm: any) => {
            if (itm.elmType === 'grid') {
              itm.columns.forEach((data: any) => {
                data.list.forEach((items: any) => {
                  if (items.type == 'dropdown') {
                    items.dropdownStatus = false
                  }
                })
              })
            }
          })
        })
      } else if (element.type === 'dropdown') {
        element.dropdownStatus = false
      }
    })
    return true
  }
  openDropdown(data: any) {
    /* istanbul ignore else */
    if (data.type == 'dropdown' && this.data.list.length > 1) {
      /* istanbul ignore else */
      if (this.closeAllDropDown()) {
        data.dropdownStatus = !data.dropdownStatus
      }
    } else {
      data.dropdownStatus = !data.dropdownStatus
    }
  }

  selectList(data: any, value: any) {
    data.options.defaultValue = value
    data.dropdownStatus = false
  }
}
